import { useCallback } from 'react';
import { useDownloadLink, useSnackbar, useTranslation, } from '@zurich/common/hooks';
import { useGetDocument } from '../hooks';
export function useDownloadOfferDocument() {
    const { flashError } = useSnackbar();
    const { t } = useTranslation();
    const { setDownloadData } = useDownloadLink();
    const getDocument = useGetDocument();
    const downloadDocumentLocally = useCallback(async (documentId) => {
        const documentResponse = await getDocument(documentId);
        if (documentResponse) {
            if (documentResponse &&
                documentResponse.fileAsBase64 &&
                documentResponse.fileName) {
                setDownloadData({
                    data: documentResponse.fileAsBase64,
                    filename: documentResponse.fileName,
                });
            }
        }
        else {
            flashError({ message: t('common:snackbar.error.downloadError') });
        }
    }, [flashError, getDocument, setDownloadData, t]);
    return { downloadDocumentLocally };
}
